"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHeader = void 0;
const React = require("react");
const CountryLanguagesService_1 = require("../services/CountryLanguagesService");
const useHeader = ({ headerData, headerElement, dictionary, }) => {
    const [activePopup, setActivePopup] = React.useState(null);
    const [isSilentLogin, setIsSilentLogin] = React.useState(false);
    const [selectedMegaMenuIndex, setSelectedMegaMenuIndex] = React.useState(null);
    const [selectedMegaMenuItem, setSelectedMegaMenuItem] = React.useState(null);
    const [isSearchOpen, setIsSearchOpen] = React.useState(false);
    const [isMenuMobileOpen, setIsMenuMobileOpen] = React.useState(false);
    const [isSearchPopupOpen, setIsSearchPopupOpen] = React.useState(false);
    const searchTriggerRef = React.useRef(null);
    const searchInputRef = React.useRef(null);
    const headerFirstLevelWrapper = React.useRef(null);
    const setCurrentMegaMenuIndex = (index) => {
        setSelectedMegaMenuIndex(index);
        setSelectedMegaMenuItem(index === null ? null : headerData.megaMenuItems[index]);
    };
    const firstLineData = {
        currentCountry: headerData.currentCountry,
        homePageUrl: headerData.homePageUrl,
        autoSuggestionEnabled: headerData.autoSuggestionEnabled,
        searchApiCountry: headerData.searchApiCountry,
        searchApiLanguage: headerData.searchApiLanguage,
        autoSuggestionResultsCount: headerData.autoSuggestionResultsCount,
        autoSuggestionApiUrl: headerData.autoSuggestionApiUrl,
        pageId: headerData.pageId,
        searchPageUrl: headerData.searchPageUrl,
        searchPlaceHolder: headerData.searchPlaceHolder,
        isAutosuggestionRedirect: headerData.isAutosuggestionRedirect,
    };
    const secondLevelData = {
        countries: CountryLanguagesService_1.countryLanguagesService.coutriesArrayBuilder(headerData.regions, headerData.globalCountry),
        currentCountry: headerData.currentCountry,
        currentCountryLabel: headerData.siteLanguageLabel,
        dipUserProfile: headerData.profile,
        auth0Config: {
            auth0Domain: headerData.dipDomain,
            auth0ClientId: headerData.dipClientId,
        },
        profileEditUrl: headerData.dipProfileDomain,
    };
    return {
        // Header
        headerElement,
        headerFirstLevelWrapper,
        // Data
        activePopup,
        setActivePopup,
        isSilentLogin,
        setIsSilentLogin,
        firstLineData,
        secondLevelData,
        megaMenuItems: headerData.megaMenuItems,
        dictionary,
        // Megamenu
        isMenuMobileOpen,
        setIsMenuMobileOpen,
        selectedMegaMenuIndex,
        selectedMegaMenuItem,
        setSelectedMegaMenuIndex: setCurrentMegaMenuIndex,
        // Search
        searchTriggerRef,
        searchInputRef,
        isSearchOpen,
        setIsSearchOpen,
        isSearchPopupOpen,
        setIsSearchPopupOpen,
    };
};
exports.useHeader = useHeader;
